import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useApi } from "../lib/api";
import { useTenant } from "../lib/tenant";

type RoadmapPhase = {
  id: string;
  title: string;
  weeks: string;
  status: string;
  outcomes: string[];
  agents: string[];
};

type Roadmap = {
  tenant_id: string;
  generated_at: string;
  horizon: string;
  phases: RoadmapPhase[];
};

export default function RoadmapPage() {
  const api = useApi();
  const { effectiveTenantId } = useTenant();
  const roadmap = useQuery({
    queryKey: ["roadmap", effectiveTenantId],
    queryFn: () => api.get<Roadmap>("/roadmap"),
  });

  return (
    <section className="flow-page roadmap-page">
      <header className="flow-hero">
        <div>
          <p className="hero-eyebrow">Roadmap</p>
          <h1>90 Tage vom Trust-Gate zum autonomen Performance Operating System.</h1>
          <p className="hero-sub">
            Die Roadmap ist kein Marketing-Zeitstrahl, sondern ein Agenten-Arbeitsplan mit Ownern, Quality Gates und Evidence.
          </p>
        </div>
        <div className="flow-score">
          <span>Horizon</span>
          <strong>{roadmap.data?.horizon ?? "90 days"}</strong>
          <small>{roadmap.data?.tenant_id ?? "tenant"}</small>
        </div>
      </header>

      {roadmap.isLoading && <p className="muted">Lade Roadmap...</p>}
      {roadmap.error && <p className="error">Roadmap nicht verfügbar.</p>}

      <div className="roadmap-timeline">
        {(roadmap.data?.phases ?? []).map((phase, index) => (
          <article key={phase.id} className={`roadmap-card ${phase.status}`}>
            <div className="roadmap-index">{index + 1}</div>
            <div>
              <div className="card-kicker">Woche {phase.weeks} · {phase.status}</div>
              <h2>{phase.title}</h2>
              <ul className="action-list">
                {phase.outcomes.map((outcome) => <li key={outcome}>{outcome}</li>)}
              </ul>
              <p className="muted small">Agenten: {phase.agents.join(", ")}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="flow-actions">
        <Link to="/app/process-landscape" className="btn primary">Prozesslandschaft öffnen</Link>
        <Link to="/app/briefings" className="btn ghost">Executive Briefing planen</Link>
      </div>
    </section>
  );
}
